/**
 * Registry de templates disponíveis no sistema
 * 
 * Este arquivo centraliza todos os templates disponíveis para seleção
 * ao criar/editar processos.
 */

import type { TemplateDefinition, TemplateSchemaOptions } from './types'
import {
  getSolicitacaoAcessoSistemaSchema,
  getSolicitacaoCriacaoAcessoInstitucionalSchema,
  getPagamentoSchema,
} from './schemas'

/**
 * Lista de templates disponíveis no sistema
 * 
 * Para adicionar um novo template:
 * 1. Crie o arquivo do schema em ./schemas/
 * 2. Exporte a função getSchema no ./schemas/index.ts
 * 3. Adicione a definição aqui no array
 */
export const templatesDisponiveis: TemplateDefinition[] = [
  {
    id: 'solicitacao_acesso_sistema',
    nome: 'Solicitação de Acesso ao Sistema',
    descricao: 'Formulário para solicitar acesso a sistemas internos como EVO, OAZEZ, PROTHEUS, SGE, pastas de rede e e-mails corporativos.',
    categoria: 'Registro de Qualidade',
    getSchema: (options?: TemplateSchemaOptions) => getSolicitacaoAcessoSistemaSchema(options),
  },
  {
    id: 'solicitacao_criacao_acesso_institucional',
    nome: 'Solicitação de Criação de Acesso Institucional',
    descricao: 'Coleta dados pessoais, contratuais e de contato para criação de acessos institucionais.',
    categoria: 'Registro de Qualidade',
    getSchema: (options?: TemplateSchemaOptions) =>
      getSolicitacaoCriacaoAcessoInstitucionalSchema(options),
  },
  {
    id: 'solicitacao_pagamento',
    nome: 'Solicitação de Pagamento',
    descricao: 'Formulário para solicitar pagamentos com data, valor e detalhamento.',
    categoria: 'Financeiro',
    getSchema: (options?: TemplateSchemaOptions) => getPagamentoSchema(options),
  },
  // Adicione novos templates aqui...
]

/**
 * Busca um template pelo ID
 */
export function getTemplateById(templateId: string): TemplateDefinition | undefined {
  return templatesDisponiveis.find(t => t.id === templateId)
}

/**
 * Busca templates por categoria
 */
export function getTemplatesByCategoria(categoria: string): TemplateDefinition[] {
  return templatesDisponiveis.filter(t => t.categoria === categoria)
}

/**
 * Lista todas as categorias disponíveis
 */
export function getCategorias(): string[] {
  const categorias = new Set(templatesDisponiveis.map(t => t.categoria).filter(Boolean))
  return Array.from(categorias) as string[]
}
